import React from 'react';

interface SummaryCoreWishesSectionProps {
  summaryCoreWishes: string;
  updateEndOfLifeCare: (field: 'summaryCoreWishes', value: string) => void;
}

const SummaryCoreWishesSection: React.FC<SummaryCoreWishesSectionProps> = ({
  summaryCoreWishes,
  updateEndOfLifeCare,
}) => {
  return (
    <div className="govuk-form-group mt-10 govuk-bp:mt-14">
      <h1 className="govuk-label-wrapper">
        <label
          className="govuk-label govuk-label--l"
          htmlFor="most-important-to-me"
        >
          Summary, core wishes and what matters most
        </label>
      </h1>
      <textarea
        className="govuk-textarea"
        id="most-important-to-me"
        name="SummaryCoreWishesSection"
        rows={5}
        autoComplete="bio"
        value={summaryCoreWishes}
        onChange={e => updateEndOfLifeCare('summaryCoreWishes', e.target.value)}
      />
    </div>
  );
};

export default SummaryCoreWishesSection;
